import { render } from "./SeatFareUpdateModal.vue?vue&type=template&id=5b2a1f29"
import script from "./SeatFareUpdateModal.vue?vue&type=script&lang=js"
export * from "./SeatFareUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__